import React, { memo } from 'react'

import {
  Button, Icon, Check, Refresh, BrushAI,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const applyIcon = <Icon svgComponent={Check} size={iconSize} notSpaced />
const regenerateIcon = <Icon svgComponent={Refresh} size={iconSize} notSpaced />
const editIcon = <Icon svgComponent={BrushAI} size={iconSize} notSpaced />

// Completed turn: the generated image and the apply / regenerate / edit actions.
function Result({ result, isGenerating, onApply, onRegenerate, onEdit }) {
  const t = useTranslation()

  return (
    <div className="image-assistant-create-tab__result">
      <div className="image-assistant-create-tab__result-image-wrapper">
        <img className="image-assistant-create-tab__result-image" src={result.url} alt={result.alt} />
      </div>
      <div className="image-assistant-panel__actions">
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={applyIcon}
          onClick={onApply}
        >
          {t('imageAssistantPanel.actions.applyAndContinue')}
        </Button>
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={regenerateIcon}
          disabled={isGenerating}
          onClick={onRegenerate}
        >
          {t('imageAssistantPanel.actions.regenerate')}
        </Button>
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-assistant-panel__action"
          icon={editIcon}
          onClick={onEdit}
        >
          {t('imageAssistantPanel.actions.editImage')}
        </Button>
      </div>
    </div>
  )
}

Result.propTypes = {
  result: shape({ id: number, url: string, alt: string }).isRequired,
  isGenerating: bool.isRequired,
  onApply: func.isRequired,
  onRegenerate: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(Result)
